import React from 'react';
import { OnboardingCard, OnboardingContainer, OnboardingContent } from '@pages/phases/Phases.styles';
import { useLeadContext } from '@context/LeadContext';
import { SelectTitle, CardsSection } from './SelectProgress.styles';
import LeadCard from './components/LeadCard/LeadCard';

const SelectProgress = () => {
  const { leads, setLead } = useLeadContext();

  return (
    <OnboardingContainer>
      <OnboardingContent>
        <OnboardingCard>
          <SelectTitle>Escolha qual processo quer acessar</SelectTitle>
          <CardsSection>
            {leads.map(lead => (
              <LeadCard lead={lead} />
            ))}
          </CardsSection>
        </OnboardingCard>
      </OnboardingContent>
    </OnboardingContainer>
  );
};

export default SelectProgress;
